import React from 'react';

import { Table, Column, HeaderCell, Cell, ColumnGroup} from 'rsuite-table';
import 'rsuite-table/dist/css/rsuite-table.css';

const baseTableProps = {
    height: 720,
};

const baseStyles = {
    zIndex: 0,
}
export const ManageAlbumsGrid = ({dataSource, artistStore, onRowClick}) => {
    return (
     <Table data={dataSource} {...baseTableProps} style={baseStyles} onRowClick={onRowClick}>
            <Column width={250} fixed sortable resizable>
                <HeaderCell>Album Name</HeaderCell>
                <Cell>{rowData => rowData.name}</Cell>
            </Column>
            <Column width={250} fixed sortable resizable>
                <HeaderCell>Album Artist</HeaderCell>
                <Cell>{rowData => artistStore.items.find(item => item.id === rowData.artistId)?.name || 'Unknown Artist'}</Cell>
            </Column>
            {/* <Column width={200} fixed sortable resizable>
                <HeaderCell>Artist</HeaderCell>
                <Cell>{rowData => rowData.artist}</Cell>
            </Column>
            <Column width={100} fixed sortable resizable>
                <HeaderCell>Track Duration</HeaderCell>
                <Cell>{rowData => rowData.duration}</Cell>
            </Column> */}
       
        </Table>
    )
}